
export enum InventoryPropertiesEnum {
    liquid, fuel, miner, building, smeltable, smelter, module
}

/**
 * InventoryItem describes an item in the game.
 */
export interface InventoryItem {
    id: string,
    name: string,
    category: "resource" | "basicMaterial" | "basicBuilding" | "scienceBuilding" | "science" | "advancedMaterial" | "advancedBuilding" | "powerBuilding" | "module",
    onUseConsume?: string,
    properties: InventoryPropertiesEnum[],
    buildPower?: number, /* indication of how fast this item can produce stuff */
    buildCost?: number, /* buildPower required to build this item in 1 cycle */
    powerUse?: number /* amount of electricity this item uses when 'on' */
}

export interface ItemQuantity {
    itemId: string,
    quantity: number,
}

export interface Recipe {
    ingredients: ItemQuantity[], /* ids of items that are required to produce the output */
    output: ItemQuantity[],
    producedIn: string, /* id of item that can produce this recipe */
    buildTime: number, /* base time required to build this item */
}
